import React from 'react';
import Contact from './components/Contact';
import {Dropdown, DropdownButton} from 'react-bootstrap'

class App extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      language:  'ja'
    }
  }

  setLanguage = (lang) => {
    this.setState({
      language: lang
    })
  }

  render() {
    const language = this.state.language
    const dropdown = <DropdownButton variant="secondary" title="Language" id="language-select">
      <Dropdown.Item as="button" onSelect={() => this.setLanguage('ja')} >日本語</Dropdown.Item>
      <Dropdown.Item as="button" onSelect={() => this.setLanguage('en')} >English</Dropdown.Item>
    </DropdownButton>
    return (
      <div className="main">
        <div className="header">
          <h5>{language === "ja" ? "国際シンポジウム実行委員会" : "International Symposium Organizing Committee"}</h5>
          {dropdown}
        </div>
        <Contact language={language}/>
      </div>
    )
  }
}

export default App;
